import React, { useState, useRef } from 'react';
import {
    Button,
    Popper,
    Paper,
    ClickAwayListener,
    TextField,
    Box, Grid, Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

/**
 * Un dropdown "Date d'édition" qui affiche deux champs date (début et fin)
 * Props:
 * - startDate (string yyyy-mm-dd)
 * - endDate (string yyyy-mm-dd)
 * - onChangeStart (fn)
 * - onChangeEnd (fn)
 */
export default function DateDropdown({ startDate, endDate, onChangeStart, onChangeEnd }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const handleClickAway = () => {
        setOpen(false);
    };

    // Convertit "yyyy-mm-dd" → "yyyy-mm" pour le champ <input type="month">
    const toMonthInput = date => {
        if (!date) return '';
        const [year, month] = date.split('-');
        return `${year}-${month}`;
    };

    // Formate la valeur "yyyy-mm" en date de début ou de fin
    const formatMonth = (value, isEnd = false) => {
        if (!value) return '';
        const [year, month] = value.split('-');
        if (!isEnd) {
            // premier jour du mois
            return `${year}-${month}-01`;
        }
        // dernier jour du mois : on crée une Date(year, monthIndex+1, 0)
        const monthIndex = parseInt(month, 10);
        const lastDay = new Date(parseInt(year, 10), monthIndex, 0).getDate();
        const dd = String(lastDay).padStart(2, '0');
        return `${year}-${month}-${dd}`;
    };

    const handleMonthChangeStart = e => {
        onChangeStart(formatMonth(e.target.value, false));
    };
    const handleMonthChangeEnd = e => {
        onChangeEnd(formatMonth(e.target.value, true));
    };

    const fromMonthInput = (value) => {
        if (!value) return '';
        const [year, month] = value.split('-');
        return `${year}-${month}-01`;
    };

    return (
        <Box>
            <Button
                ref={anchorRef}
                variant="outlined"
                size="small"
                endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                onClick={handleToggle}
                style={{ /*height: 55, width: '100%',*/ color: '#4b4949' }}
            >
                Mois du décompte
            </Button>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                modifiers={[
                { name: 'offset', options: { offset: [0, 8] } }
                ]}
                style={{ zIndex: 1300 }}
            >
                <ClickAwayListener onClickAway={handleClickAway}>
                    <Paper sx={{ p: 2, display: 'flex', width: '100%',
                        maxWidth: {
                            xs: '80vw',  // on extra‑small (mobile), max at 90% of viewport width
                            sm: 250,     // from “sm” (600px) up, max at 300px
                            md: 250,      // from “md” (900px) up, max at 400px
                            lg: 250      // from “md” (900px) up, max at 400px
                        }}}>
                        <Grid container alignItems="center" spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h5">
                                    Sélectionner une période
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ mb: 0 }}>
                                <TextField
                                    label="Du"
                                    type="month"
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    value={toMonthInput(startDate)}
                                    onChange={handleMonthChangeStart}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ mb: 0 }}>
                                <TextField
                                    label="Au"
                                    type="month"
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    value={toMonthInput(endDate)}
                                    onChange={handleMonthChangeEnd}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>


                    </Paper>
                </ClickAwayListener>
            </Popper>
        </Box>
    );
}
